import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import guardian from "./Assets/images/guardianGuide.png";
import calm from "./Assets/images/calmYou.png";
import mojo from "./Assets/images/mojo.png";
import myhood from "./Assets/images/myHood.png";
import kolet from "./Assets/images/kolet.png";
import swift from "./Assets/images/swiftCarts.png";
import coming from "./Assets/images/comingSoon.png";
import arrow from "./Assets/svgs/arrow-up-right-01.svg";
import { ReactComponent as Cancel } from "./Assets/svgs/Cancel.svg";
import swift1 from "./Assets/swift/image 28.png";
import swift2 from "./Assets/swift/image 17.png";
import swift3 from "./Assets/swift/image 19.png";
import swift4 from "./Assets/swift/image 21.png";
import swift5 from "./Assets/swift/image 23.png";
import swift6 from "./Assets/swift/image 25.png";
import swift7 from "./Assets/swift/image 26.png";
import swift8 from "./Assets/swift/Frame.png";
import swift9 from "./Assets/swift/image 29.png";
import swift10 from "./Assets/swift/image 31.png";
import swift11 from "./Assets/swift/image 34.png";
import swift12 from "./Assets/swift/image 36.png";
import swift13 from "./Assets/swift/image 38.png";
import myhood1 from "./Assets/myHood/image 47.png";
import myhood2 from "./Assets/myHood/image 49.png";
import myhood3 from "./Assets/myHood/image 50.png";
import myhood4 from "./Assets/myHood//image 51.png";
import myhood5 from "./Assets/myHood/image 52.png";
import myhood6 from "./Assets/myHood/image 53.png";
import myhood7 from "./Assets/myHood/image 54.png";
import myhood8 from "./Assets/myHood/image 55.png";
import myhood9 from "./Assets/myHood/image 56.png";
import myhood10 from "./Assets/myHood/image 57.png";
import myhood11 from "./Assets/myHood/image 59.png";
import myhood12 from "./Assets/myHood/image 61.png";
import myhood13 from "./Assets/myHood/image 62.png";
import myhood14 from "./Assets/myHood/image 63.png";
import kolet1 from "./Assets/Kolet/image 64.png";
import kolet2 from "./Assets/Kolet/image 65.png";
import kolet3 from "./Assets/Kolet/image 66.png";
import kolet4 from "./Assets/Kolet/image 67.png";
import kolet5 from "./Assets/Kolet/image 68.png";
import kolet6 from "./Assets/Kolet/image 69.png";
import kolet7 from "./Assets/Kolet/image 70.png";
import kolet8 from "./Assets/Kolet/image 71.png";
import kolet9 from "./Assets/Kolet/image 74.png";
import kolet10 from "./Assets/Kolet/image 76.png";
import kolet11 from "./Assets/Kolet/image 72.png";
import guard1 from "./Assets/Guardian/image 77.png";
import guard2 from "./Assets/Guardian/image 78.png";
import guard3 from "./Assets/Guardian/image 79.png";
import guard4 from "./Assets/Guardian/image 80.png";
import guard5 from "./Assets/Guardian/image 81.png";
import guard6 from "./Assets/Guardian/image 82.png";
import guard7 from "./Assets/Guardian/image 89.png";
import guard8 from "./Assets/Guardian/image 83.png";
import guard9 from "./Assets/Guardian/image 84.png";
import guard10 from "./Assets/Guardian/image 85.png";
import guard11 from "./Assets/Guardian/image 90.png";
import guard12 from "./Assets/Guardian/image 88.png";
import mojo1 from "./Assets/mojo/image 91.png";
import mojo2 from "./Assets/mojo/image 92.png";
import mojo3 from "./Assets/mojo/image 93.png";
import mojo4 from "./Assets/mojo/image 94.png";
import mojo5 from "./Assets/mojo/image 95.png";
import mojo6 from "./Assets/mojo/image 96.png";
import mojo7 from "./Assets/mojo/image 97.png";
import calm1 from "./Assets/calmYou/image 100.png";
import calm2 from "./Assets/calmYou/image 101.png";
import calm3 from "./Assets/calmYou/image 102.png";
import calm4 from "./Assets/calmYou/image 103.png";
import calm5 from "./Assets/calmYou/image 104.png";
import calm6 from "./Assets/calmYou/image 106.png";
import calm7 from "./Assets/calmYou/image 107.png";
import calm8 from "./Assets/calmYou/image 109.png";
import calm9 from "./Assets/calmYou/image 111.png";
import coming1 from "./Assets/comingSoon/image 112.png";
import coming2 from "./Assets/comingSoon/image 113.png";
import coming3 from "./Assets/comingSoon/image 117.png";
import coming4 from "./Assets/comingSoon/image 116.png";
import dami1 from "./Assets/DamisiPortfolio/image 132.png";
import dami2 from "./Assets/DamisiPortfolio/iPhone-15pro.png";
import dami3 from "./Assets/DamisiPortfolio/iPhone15pro-1.png";
import dami4 from "./Assets/DamisiPortfolio/Frame 2.png";
import dami5 from "./Assets/DamisiPortfolio/image 133.png";
import dami6 from "./Assets/DamisiPortfolio/image 128.png";
import dami7 from "./Assets/DamisiPortfolio/image 129.png";
import ije1 from "./Assets/ije/Ip.png";
import ije2 from "./Assets/ije/Bento.png";
import ije3 from "./Assets/ije/Section.png";
import ije4 from "./Assets/ije/Section-1.png";
import ije5 from "./Assets/ije/Section-2.png";
import ije6 from "./Assets/ije/Section-3.png";
import ije7 from "./Assets/ije/Section-4.png";
import ije8 from "./Assets/ije/Section-5.png";
import ije9 from "./Assets/ije/Section-6.png";
import ije10 from "./Assets/ije/Section-7.png";
import ije11 from "./Assets/ije/Section-8.png";
import ije12 from "./Assets/ije/Section-9.png";
import ije13 from "./Assets/ije/Section-10.png";
import ije14 from "./Assets/ije/Section-11.png";
import ije15 from "./Assets/ije/Section-12.png";
import ije16 from "./Assets/ije/Section-13.png";
import ije17 from "./Assets/ije/Section-14.png";

const projects = [
  {
    id: 8,
    frontScreen: ije1,
    title: "Ije Case Study",
    description: "Digital-first loan application",
    desc: "Ije is a financial platform that helps African students fund their education abroad through loans, offering a seamless application process and direct disbursement with a structured repayment model for lenders.",
    type: ["IOS", "Andriod", "Web Based", "Case Study", "Design System", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [ije2, ije3, ije4, ije5, ije6, ije7, ije8, ije9, ije10, ije11, ije12, ije13, ije14, ije15, ije16, ije17],
    url: "https://www.ijefund.com/",
  },
  {
    id: 7,
    frontScreen: dami2,
    title: "Portfolio",
    description: "High performance portfolio",
    desc: "Crafting High-Performance Web and Mobile Applications with a Focus on Scalability and Innovation.",
    type: ["IOS", "Case Study", "Design System", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [dami1, dami2, dami3, dami4, dami5, dami6, dami7],
  },

  {
    id: 6,
    frontScreen: swift,
    title: "SwiftCarts",
    description: "Creating Seamless E-Commerce Experience",
    desc: "In the ever-evolving landscape of e-commerce, providing a seamless and efficient checkout experience is paramount to customer satisfaction.",
    type: ["IOS", "Case Study", "Design System", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [swift1, swift2, swift3, swift4, swift5, swift6, swift7, swift8, swift9, swift10, swift11, swift12, swift13],
  },
  {
    id: 5,
    frontScreen: myhood,
    title: "MyHood",
    description: "Transforming Communities",
    desc: "The myHood app: Revolutionizing community bonds through digital connectivity. Explore its features and real-world impact.",
    type: ["IOS", "Andriod", "Web", "Case Study", "Design System", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [myhood1, myhood2, myhood3, myhood4, myhood5, myhood6, myhood7, myhood8, myhood9, myhood10, myhood11, myhood12, myhood13, myhood14],
    url: "https://myhood.ng",
  },
  {
    id: 3,
    frontScreen: mojo,
    title: "Mojo Quiz App",
    description: "Revolutionizing Soccer Knowledge with the MOJO Quiz App",
    desc: "In the realm of sports and education, the Soccer Quiz App emerges as a game-changer, blending the excitement of soccer trivia with an engaging quiz experience. ",
    type: ["IOS", "Andriod", "Case Study", "Design System", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [mojo1, mojo2, mojo3, mojo4, mojo5, mojo6, mojo7],
  },
  {
    id: 4,
    frontScreen: kolet,
    title: "Kolet",
    description: "Transforming Payments with Ease",
    desc: "KOLET: Transforming Payments with Ease",
    type: ["IOS", "Andriod", "Web", "Case Study", "Design System", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [kolet1, kolet2, kolet3, kolet4, kolet5, kolet6, kolet7, kolet8, kolet9, kolet10, kolet11],
  },
  {
    id: 11,
    frontScreen: coming,
    title: "Coming Soon",
    description: "Our 'Coming Soon' landing page",
    desc: "Project Impact of the Coming Soon Landing Page",
    type: ["IOS", "Andriod", "Web", "Case Study", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [coming1, coming2, coming3, coming4],
  },
  {
    id: 1,
    frontScreen: guardian,
    title: "GuardianGuide",
    description: "Empowering Parents and Nurturing Children",
    desc: "GuardianGuide is more than an app; it's your dedicated parenting partner, offering tools to monitor child development, daily parenting tips, and childcare reminders.",
    type: ["IOS", "Andriod", "Case Study", "Design System", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [guard1, guard2, guard3, guard4, guard5, guard6, guard7, guard8, guard9, guard12, guard11, guard10],
  },
  {
    id: 2,
    frontScreen: calm,
    title: "CalmYou",
    description: "Unlock Inner Peace and Wellness",
    desc: "I designed this app to guide you on a journey toward inner peace and holistic wellness. Whether you seek stress relief, mindfulness, or emotional balance, our user-friendly app provides the tools you need. Embrace tranquility, clarity, and emotional strength. Your well-being journey begins here. ",
    type: ["IOS", "Andriod", "Web", "Case Study", "User Experience (UX)", "User Interface (UI)"],
    caseStudy: [calm1, calm2, calm3, calm4, calm5, calm6, calm7, calm8, calm9],
  },
];
console.log(dami2);
function Projects() {
  const [darkMode, setDarkMode] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const savedMode = localStorage.getItem("theme");
    const systemPreference = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (savedMode === "dark" || (!savedMode && systemPreference)) {
      document.documentElement.classList.add("dark");
      setDarkMode(true);
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  };
  return (
    <>
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className=" w-full  flex justify-center items-center h-fit pt-[128px] 100:px-[32px] sm:px-[64px]">
        <div className="100:w-full 2xl:w-[1312px] flex-col justify-start items-center gap-12 inline-flex">
          <div className=" w-full justify-start items-start gap-2.5 inline-flex">
            <div className="w-full p-2.5 flex-col justify-start items-start gap-4 inline-flex">
              <h1 className={`self-stretch ${darkMode ? "text-[#F5F6F6]" : "text-[#393c40]"} 100:text-3xl md:text-5xl font-semibold font-inter`}>Projects & Case Studies</h1>
              <div className={`h-px w-full ${darkMode ? "bg-[#A9B2B7]" : "bg-[#ccd2d5]"}`} />
            </div>
          </div>
          <div className="h-fit w-full rounded-2xl flex-1 flex-wrap justify-start items-center gap-6 inline-flex">
            {projects.map((item, index) => (
              <div
                key={item.key}
                style={{ animationDelay: `${index * 0.2}s`, backgroundImage: `url(${item.frontScreen})`, backgroundSize: "cover", backgroundPosition: "center" }}
                className={` project-card 100:w-full flex-grow h-[365px] bg-no-repeat rounded-[16px] lg:w-[49%] `}
              >
                <div className={`w-full p-6 rounded-[16px] flex flex-col justify-between items-center h-full ${darkMode ? "bg-black/50" : "bg-black/60"}`}>
                  <div className="self-stretch h-[71px] flex-col justify-start items-start gap-2.5 flex">
                    <h3 className={`${darkMode ? "text-[#f5f6f6]" : "text-[#f5f6f6]"} text-[32px] font-semibold font-inter`}>{item.title}</h3>
                    <p className={`${darkMode ? "text-[#dee7eb]" : "text-[#ccd2d5]"} text-base font-normal font-inter leading-snug`}>{item.description}</p>
                  </div>
                  <div className=" w-full flex justify-end items-end">
                    <button onClick={() => setData(item)} className={`h-[43px] px-[25px] hover:bg-[#fd992f]  py-[5px] bg-[#ffb600] rounded-3xl shadow-customWhite justify-center items-center gap-2.5 inline-flex`}>
                      <div className="text-[#25282b] text-lg font-medium flex justify-center items-center gap-1.5 font-inter capitalize">
                        View More <img src={arrow} alt="" />
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer darkMode={darkMode} />
      {/* {data && (
        <>
          <div className={` transition-opacity flex-col  justify-ceneter item-center  flex  fixed left-0 top-0 z-50  ${darkMode ? "bg-slate-200" : "bg-slate-700"} bg-opacity-60 backdrop-blur-lg w-full h-full`}>
            <div className=" px-[24px] fixed pt-3 w-full flex justify-end items-end">
              <div onClick={() => setData(null)} className={` w-12 h-12 top-[25px] cursor-pointer justify-center flex  items-center 100:right-0 md:right-[40px] relative  ${darkMode ? " bg-gray-600" : "bg-gray-400"} rounded-3xl  `}>
                <Cancel className={`text-[#F5F6F6]`} />
              </div>
            </div>
            <div className=" w-full justify-center flex items-center h-full">
              <div className="  h-[80vh] xl:w-[1000px] 100:w-[90%]  overflow-y-scroll">
                <div className={` p-6 h-fit justify-start overflow-y-scroll w-full shadow-lg  rounded-[16px]  ${darkMode ? "bg-[#25282b]" : "bg-[#f5f6f6]"}  gap-6 flex flex-col items-start  `}>
                  <div className="w-full py-px flex-col justify-center items-center gap-2.5 flex">
                    <h1 className={`self-stretch ${darkMode ? "text-[#F5F6F6]" : "text-[#25282b]"} text-5xl font-semibold font-inter`}>{data.title}</h1>
                    <p className={`self-stretch ${darkMode ? "text-[#ccd2d5]" : "text-[#637077]"} text-base font-normal font-inter leading-[25px]`}>{data.desc}</p>
                  </div>

                  <div className="w-full flex-wrap justify-start items-start gap-2.5 inline-flex">
                    {data.type.map((item, index) => (
                      <div key={index} className="px-4 py-2 bg-[#e8f1ff] rounded-lg flex-col justify-center items-center gap-4 inline-flex">
                        <div className="text-center text-[#637077] text-xs font-semibold font-inter capitalize">{item}</div>
                      </div>
                    ))}
                  </div>
                  <div className="w-full flex-col justify-start items-center gap-2.5 inline-flex">
                    {data.caseStudy.map((item, index) => (
                      <>
                        <img key={index} src={item} alt="Case Study" />
                      </>
                    ))}
                    <div className=" w-full m-4 px-4 flex justify-end items-end">
                      <a
                        href={data.url}
                        className={`h-[43px] px-[25px] hover:bg-[#fd992f] text-[#25282b] text-lg font-medium  font-inter capitalize py-[5px] bg-[#ffb600] rounded-3xl ${
                          darkMode ? "shadow-customWhite" : " shadow-customBlack"
                        }  justify-center items-center gap-2.5 inline-flex`}
                      >
                        Explore & See My Work
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
      {data && (
        <>
          <div className={`transition-opacity flex-col justify-center items-center flex fixed left-0 top-0 z-50 ${darkMode ? "bg-slate-200" : "bg-slate-700"} bg-opacity-60 backdrop-blur-lg w-full h-full`}>
            {/* Close Button */}
            <div className="px-[24px] top-4 fixed pt-3 w-full flex justify-end items-end">
              <div onClick={() => setData(null)} className={`w-12 h-12 top-[25px] cursor-pointer justify-center flex items-center relative ${darkMode ? "bg-gray-600" : "bg-gray-400"} rounded-3xl`}>
                <Cancel className={`text-[#F5F6F6]`} />
              </div>
            </div>

            {/* Modal Content */}
            <div className="w-full justify-center flex items-center h-full">
              <div className="h-[80vh] xl:w-[1000px] w-[90%] overflow-y-scroll">
                <div className={`p-6 h-fit justify-start overflow-y-scroll w-full shadow-lg rounded-[16px] ${darkMode ? "bg-[#25282b]" : "bg-[#f5f6f6]"} gap-6 flex flex-col items-start`}>
                  {/* Title & Description */}
                  <div className="w-full flex-col justify-center items-center gap-2.5 flex">
                    <h1 className={`self-stretch ${darkMode ? "text-[#F5F6F6]" : "text-[#25282b]"} text-5xl font-semibold font-inter`}>{data.title}</h1>
                    <p className={`self-stretch ${darkMode ? "text-[#ccd2d5]" : "text-[#637077]"} text-base font-normal font-inter leading-[25px]`}>{data.desc}</p>
                  </div>

                  {/* Types */}
                  <div className="w-full flex-wrap justify-start items-start gap-2.5 inline-flex">
                    {data.type.map((item, index) => (
                      <div key={index} className="px-4 py-2 bg-[#e8f1ff] rounded-lg flex-col justify-center items-center gap-4 inline-flex">
                        <div className="text-center text-[#637077] text-xs font-semibold font-inter capitalize">{item}</div>
                      </div>
                    ))}
                  </div>

                  {/* Case Study Images */}
                  <div className="w-full flex-col justify-start items-center gap-2.5 inline-flex">
                    {data.caseStudy.map((item, index) => (
                      <img key={index} src={item} alt="Case Study" />
                    ))}

                    {/* Open Link Button */}
                    <div className="w-full m-4 px-4 flex justify-end items-end">
                      <a
                        href={data.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`h-[43px] px-[25px] hover:bg-[#fd992f] text-[#25282b] text-lg font-medium font-inter capitalize py-[5px] bg-[#ffb600] rounded-3xl ${
                          darkMode ? "shadow-customWhite" : "shadow-customBlack"
                        } justify-center items-center gap-2.5 inline-flex`}
                      >
                        Explore My Work
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Projects;
